import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface RagEmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
  className?: string;
}

export function RagEmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: RagEmptyStateProps) {
  return (
    <div
      className={cn(
        "rounded-2xl border border-[var(--lm-border-card)] bg-white px-6 py-16 text-center shadow-[var(--shadow-card)] dark:border-dashed dark:border-white/10 dark:bg-glass-bg dark:shadow-none dark:backdrop-blur-sm",
        className
      )}
    >
      <Icon className="mx-auto mb-3 h-12 w-12 text-[#7c3aed]/45 dark:text-violet-400/45" strokeWidth={1.5} />
      <h3 className="mb-1.5 text-base font-medium text-[var(--lm-foreground-strong)] dark:text-white">{title}</h3>
      <p className="mx-auto mb-5 max-w-md text-[13px] text-[var(--lm-muted)] dark:text-slate-400">{description}</p>
      {action}
    </div>
  );
}
